const PaymentMethodRef = Object.freeze({
    BACS: 'bacs',
    CARD_CLOVER_CHIP_AND_PIN: 'card-clover-chip-and-pin',
    CARD_DOJO_CHIP_AND_PIN: 'card-dojo-chip-and-pin',
    CARD_MELLON_WEBECR: 'card-mellon-webecr',
    CARD_MOTO: 'card-moto',
    CARD_OFFLINE: 'card-offline',
    CARD_PAYMENT_EXPRESS: 'card-payment-express',
    CARD_PAYPAL_HERE: 'card-paypal-here',
    CARD_PAYYO_CHIP_AND_PIN: 'card-payyo-chip-and-pin',
    CARD_SAGE_PAY: 'card-sage-pay',
    CARD_SAGE_PAY_BACK_OFFICE: 'card-sage-pay-back-office',
    CARD_SAGEPAY_SERVER: 'card-sagepay-server',
    CARD_VERIFONE_CHIP_AND_PIN: 'card-verifone-chip-and-pin',
    CARD_WORLDPAY_CHIP_AND_PIN: 'card-worldpay-chip-and-pin',
    CASH: 'cash',
    CHEQUE: 'cheque',
    FLEXI_VOUCHER: 'flexi-voucher',
    GIFT_VOUCHER: 'gift-voucher',
    GOCARDLESS: 'bank-gocardless-jsflow-bacs',
    INVOICE: 'invoice',
    PAYMENT_ON_ACCOUNT: 'payment-on-account',
    TESCO_VOUCHER_IRELAND: 'tesco-voucher-ireland',
    TESCO_VOUCHER_UK: 'tesco-voucher-uk',
    VOUCHER: 'voucher',
});

module.exports = PaymentMethodRef;
